import Model from 'flarum/common/Model';

export default class Question extends Model {
  apiEndpoint() {
    return '/qwn-questions' + (this.exists ? '/' + this.data.id : '');
  }
}

Object.assign(Question.prototype, {
  type: Model.attribute('type'),
  content: Model.attribute('content'),
  options: Model.attribute('options'),
  answers: Model.attribute('answers'),
  settings: Model.attribute('settings'),
  questionnaire_id: Model.attribute('questionnaire_id'),
  bank_id: Model.attribute('bank_id'),
});
